import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { LynxColors } from "src/app/models/lynxColors.model";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class ColorsService {
  constructor(private http: HttpClient) {}

  public getColors(): Observable<LynxColors[]> {
    return this.http.get<LynxColors[]>(environment.assetsDataPath + "colorsPressets.json");
  }
}
